import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Template = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Template' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,3 L23,3 L23,21 L1,21 L1,3 Z M1,8 L23,8 M7,8 L7,21' />
  </StyledIcon>
);
